
import {fadeIn, fadeOut} from './fade.js';

export default class {
    //星ボタンクリックのアクション
    
    constructor() {
        this.showedElm;
        this.overlay = document.getElementById('js-overlay');
        this.scrollArea = document.getElementById('js-schedule');
        this.confirmBtns = document.querySelectorAll('.js-confirm-btn');

        [].forEach.call(this.confirmBtns, (btn) => {
            btn.addEventListener('click', (e) => {
                this.removeBaloon();
            });
        });

        window.addEventListener('mouseup', (e) => {
            this.onClick(e)
        });
    }

    onClick(e) {
        const isShow = this.removeBaloon();
        //すでに表示されているものがあれば消してから処理
        if(isShow) {
            setTimeout(()=> {
                this.clickHandle(e);
                this.delayFadeOut();
            }, 300);
        } else {
            this.clickHandle(e);
            this.delayFadeOut();
        }
    }
    
    delayFadeOut() {
        if(this.showedElm) {
            if(!this.showedElm.classList.contains('js-autohide')) {
                return false;
            }
            setTimeout(()=> {
                this.removeBaloon();
            }, 1000);
            return true;
        }
        return false;
    }

    clickHandle(e) {
        const target = e.target;
        if(target) {
            const btn = target.closest('.js-star');
            if(btn) {
                e.preventDefault();
                const showId = btn.getAttribute('data-test');
                const pos = this.getPos(btn);
                let showEl;
                if(showId) {
                    showEl = document.getElementById(showId)
                } else {
                    showEl = document.getElementById('js-mystar-confirm')
                }
                this.showedElm = showEl;
                showEl.removeAttribute('style');
                fadeIn(showEl);
                this.overlay.classList.add('is-show');
            }
        }
    }

    removeBaloon() {
        if(this.showedElm) {
            fadeOut(this.showedElm);
            this.showedElm = null;
            this.overlay.classList.remove('is-show');
            return true;
        }
        return false;
    }

    getPos(el) {
        const rect = el.getBoundingClientRect();
        const pos = {top: rect.top, left: rect.left};
        return pos;
    }

}
